import { c as _c } from "react/compiler-runtime";
export default function ToggleIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enableBackground: "new 0 0 200 124.3"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g id="Gruppe_9"><path id="Pfad_10" fill="#4AB7BE" d={"M70.8,53.7c4.6,4.7,4.6,12.3,0,17l-49.6,49.6c-11,11-28-6.1-17-17l41.1-41.1L4.2,21.1\n\t\tc-11-11,6.1-28,17-17L70.8,53.7"} /><path id="Pfad_11" fill="#4AB7BE" d={"M133.4,53.7c4.6,4.7,4.6,12.3,0,17l-49.6,49.6c-11,11-28-6.1-17-17l41.1-41.1L66.7,21.1\n\t\tc-11-11,6.1-28,17-17L133.4,53.7"} /><path id="Pfad_12" fill="#4AB7BE" d={"M195.9,53.7c4.6,4.7,4.6,12.3,0,17c-16.5,16.5-33.1,33.1-49.6,49.6c-11,11-28-6.1-17-17\n\t\tl41.1-41.1l-41.1-41.1c-11-11,6.1-28,17-17L195.9,53.7"} /></g>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg version="1.1" id="Ebene_1" x="0px" y="0px" viewBox="0 0 200 124.3" style={t1} className={className}>{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}